import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Typography from '@mui/material/Typography';
import ReorderIcon from '@mui/icons-material/Reorder';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import Button from '@mui/material/Button';
import useChats from '../../hooks/useChats';
import { useTheme } from '@mui/material/styles';

const drawerWidth = 250;


type Props = {
    onSave: () => void,
    onClose: () => void,
    openProperties: () => void,
    openUtterances: () => void,
    openImportUtterances: () => void,
    saving: boolean
}


export default function MenuAppBar({ onClose, onSave,saving, openProperties, openUtterances, openImportUtterances }: Props) {
    const [auth, setAuth] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);    
    const theme = useTheme();    

    return (
        <AppBar position="static">
            <Toolbar>
                <Button startIcon={<SaveIcon style={{ color: theme.palette.success.main }} />} title="Save" onClick={onSave} style={{ color: 'white' }} disabled={saving}>
                    {saving ? 'Saving' : 'Save'}
                </Button>

                <Button title="Flow Name & Intent" onClick={openProperties} startIcon={<DriveFileRenameOutlineIcon style={{ color: 'lightblue' }} />} style={{ color: 'white' }} disabled={saving}>
                    Flow Name & Intent
                </Button>

                <Button title="Import Utterances" onClick={openImportUtterances} startIcon={<PlaylistAddIcon style={{ color: theme.palette.info.main }} />} style={{ color: 'white' }} disabled={saving}>
                    Import Utterances
                </Button>


                <Button title="Utterances" onClick={openUtterances} startIcon={<AppRegistrationIcon style={{ color: theme.palette.info.main }} />} style={{ color: 'white' }} disabled={saving}>
                    Edit Utterances
                </Button>

                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'end', marginRight: 5 }}>
                    <Button title="Close" onClick={onClose} startIcon={<ExitToAppIcon style={{ color: 'lightblue' }} />} style={{ color: 'white' }} disabled={saving}>
                        Close
                    </Button>
                </Box>
            </Toolbar>
        </AppBar >
    );
}